type OsType = 'Linux' | 'Android' | 'Windows' | 'iOS' | 'macOS' | 'unknown';

const iOS = new Set([
  'iPad Simulator',
  'iPhone Simulator',
  'iPod Simulator',
  'iPad',
  'iPhone',
  'iPod',
]);

export const getOS = (): OsType => {
  if (navigator.userAgent.match(/Android/i)) {
    return 'Android';
  }
  if (navigator.userAgent.match(/Windows/i)) {
    return 'Windows';
  }
  if (navigator.userAgent.match(/Mac/i)) {
    if (iOS.has(navigator.platform) || 'ontouchend' in document) {
      return 'iOS';
    }
    return 'macOS';
  }
  if (navigator.userAgent.match(/Linux/i)) {
    return 'Linux';
  }
  return 'unknown';
};

export const isApple = getOS() === 'iOS' || getOS() === 'macOS';

export const isPhone =
  (getOS() === 'iOS' || getOS() === 'Android') &&
  Math.min(window.innerWidth, window.innerHeight) < 600;
